<section class="estado-page">
    <div class="container">
        <article class="estado-card" role="alert">
            <p class="estado-card__kicker">Tesorería Municipal · Pago en línea</p>

            <div class="estado-card__icono" aria-hidden="true">
                <i class="fa-solid fa-xmark"></i>
            </div>

            <h1 class="estado-card__titulo">No pudimos completar su pago</h1>
            <p class="estado-card__texto">
                El pago fue cancelado o el banco no lo autorizó. Puede intentarlo de nuevo, de preferencia con otra tarjeta.
            </p>

            <p class="estado-card__aviso">
                <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                <span>Si en su estado de cuenta aparece un cargo por este pago, no lo repita: comuníquese con Tesorería para verificarlo.</span>
            </p>

            <div class="estado-card__acciones">
                <button type="button" class="estado-btn estado-btn--primario" (click)="Regresar()">
                    <i class="fa-solid fa-rotate-right" aria-hidden="true"></i> Volver a intentar
                </button>
            </div>
        </article>

        <aside class="estado-ayuda" *ngIf="(telefonos && telefonos.length) || (emails && emails.length)">
            <h2 class="estado-ayuda__titulo">¿Necesita ayuda?</h2>
            <div class="estado-ayuda__canales">
                <a class="estado-ayuda__canal" *ngFor="let tel of telefonos" [href]="'tel:' + tel">
                    <i class="fa-solid fa-phone" aria-hidden="true"></i> {{ tel }}
                </a>
                <a class="estado-ayuda__canal" *ngFor="let correo of emails" [href]="'mailto:' + correo">
                    <i class="fa-solid fa-envelope" aria-hidden="true"></i> {{ correo }}
                </a>
            </div>
        </aside>
    </div>
</section>
